import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

const PREF_KEY = "sana_card_show_name";

/** Nombre de pila para la tarjeta + preferencia "Mostrar mi nombre" (localStorage, activada por defecto). */
export function useCardName() {
  const { user } = useAuth();
  const { data: firstName = null } = useQuery({
    queryKey: ["profile-first-name", user?.id],
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data } = await supabase.from("profiles").select("first_name").eq("user_id", user!.id).maybeSingle();
      const n = data?.first_name?.trim();
      return n ? n : null;
    },
  });
  const [showName, setShowNameState] = useState<boolean>(() => {
    try { return localStorage.getItem(PREF_KEY) !== "0"; } catch { return true; }
  });
  useEffect(() => {
    try { localStorage.setItem(PREF_KEY, showName ? "1" : "0"); } catch { /* sin almacenamiento */ }
  }, [showName]);
  return { firstName, showName, setShowName: setShowNameState, cardName: showName ? firstName : null };
}
